// Opportunity fields that had no existing equivalent in the system. `id`
// values mirror the API (Opportunity::LIST_FIELDS), `value` is the label.

export const eligibilityOptions = [
  { id: "companies", value: "Companies" },
  { id: "solopreneurs", value: "Solopreneurs" },
  { id: "freelancers", value: "Freelancers" },
  { id: "professionals", value: "Professionals" },
]

export const businessFunctionOptions = [
  { id: "technology", value: "Technology" },
  { id: "operations", value: "Operations" },
  { id: "finance", value: "Finance" },
  { id: "marketing", value: "Marketing" },
  { id: "sales", value: "Sales" },
  { id: "product", value: "Product" },
  { id: "strategy", value: "Strategy" },
  { id: "legal", value: "Legal" },
  { id: "other", value: "Other" },
]

export const geographicEligibilityOptions = [
  { id: "northeast", value: "Northeast" },
  { id: "southeast", value: "Southeast" },
  { id: "midwest", value: "Midwest" },
  { id: "southwest", value: "Southwest" },
  { id: "west", value: "West" },
  { id: "international", value: "International" },
]

// The existing opportunity status values.
export const opportunityStatusOptions = [
  { id: "open", value: "Open" },
  { id: "close", value: "Closed" },
]

export const findOption = (options, id) =>
  options.find((option) => option.id === id)

export const optionLabel = (options, id) => findOption(options, id)?.value
